.trashIcon {
    margin-left: 16px;
    transform: translateY(10px);
    &:hover {
        color: darkred;
    }
}

.thumb {
    display: flex;
    flex-direction: column;
    min-height: 254px;
    padding: 20px 24px;
    background-color: white;
    border: 1px solid #e3e6eb;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: background-color 0.2s ease;
    &:hover {
        background-color: #e8f0fe;
    }
}

.title {
    font-size: 22px;
    line-height: 1.3;
    font-family: Hanken Grotesk;
    font-weight: 600;
    color: #102442;
    text-align: center;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
}

.filenameText {
    font-size: 16px;
    line-height: 1.3;
    font-family: Hanken Grotesk;
    font-weight: 600;
    color: #475467;
    text-align: center;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
}

.unlockIcon {
    font-size: 20px;
}
.unlock {
    width: 48px;
    font-family: Hanken Grotesk;
    font-weight: 600;
    color: #333333;
}
.input {
    min-width: 0;
    height: 40px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 0 12px;
    font-size: 14px;
    color: #333333;
    &:focus {
        border: 1px solid #333333;
    }
}
